<template>
  <div>
    <!-- IMAGEN PRINCIPAL -->
    <div class="mt-5">
      <img src="@/assets/fondo_retiro.png" alt="Home" style="width:100%;">
      <div class="text-block text-center lg:w-1/2">
        <!-- <p class="text-xl lg:text-5xl font-medium">Consigue Un Préstamo De Forma Rápida Y Segura</p> -->
        <!-- <p class="text-base lg:text-lg text-left w-3/5">Como Miembro Del Fondo De Ayuda Sindical Tienes La Oportunidad De Conseguir El Préstamo Que Necesitas De Forma Segura</p> -->
        <!-- <button @click="goToDIV()" class="bg-lightAqua hover:bg-darkAqua text-white font-bold py-2 px-4 rounded mt-5">
        Descargar formato de solicitud de préstamo
        </button> -->
      </div>
    </div>

    <!-- PASOS DE SOLICITUD -->

    <div class="w-full" style="">
      <p class="text-lightGray">.</p>
      <p class="text-5xl text-center mt-5 font-bold leading-none title">Beneficios Del Fondo de Retiro:</p>
      <!-- <p class="p-4 text-3xl sm:text-xl md:text-base lg:text-base xl-text-base text-darkGray text-center mt-5 leading-none">Para solicitar tu préstamo solo necesitas seguir los siguientes pasos:</p> -->
      
      <div class="p-2 mt-10 mb-5 lg:inline-flex xl:inline-flex" style="display:flex;justify-content:center;">
        <div class="grid md:grid-cols-12 grid-cols-1 gap-8" style="width:80%;">
          <div class="md:col-span-2 md:flex-none flex justify-center">
            <div style="display:table;">
              <div style="display:table-cell;vertical-align:top">
                <img src="@/assets/beneficio-jubilacion.svg" alt="">
              </div>
            </div>
          </div>
          <div class="md:col-span-10 text-left font-medium">
            <p class="text-4xl text-darkAqua font-semibold md:text-left text-center text-poppins">Por Jubilación</p>
            <p class="text-2xl mt-2 md:text-left text-center text-roboto">
              En caso de cumplir con 30 años de servicio (para hombres) 
              y 28 años (para mujeres) del subsistema federalizado, o lo que indique
              la Ley vigente del ISSSTE.
            </p>
            <p class="text-2xl mt-5 md:text-left text-center text-roboto">
              Los Socios que se inscribieron hasta el día 15 de Mayo de 2010, y se jubilen, recibirán los
              <span class="font-black">$27,500.00</span>, sólo si han realizado sus aportaciones de forma continua durante cinco
              años desde su inscripción. Este lapso se contabilizará a partir del mes de Mayo de 2006.
            </p>
            <p class="text-2xl mt-5 md:text-left text-center text-roboto">
              Si el Socio no aportó de manera continua durante cinco años completos al Fondo de Retiro del FAS, 
              al jubilarse tendrá derecho a recibir la totalidad de las aportaciones.
            </p>
          </div>
          <div class="md:col-span-2 md:flex-none flex justify-center">
            <div style="display:table">
              <div style="display:table-cell;vertical-align:top">
                <img src="@/assets/beneficio-pension.svg" alt="">
              </div>
            </div>
          </div>
          <div class="md:col-span-10 text-left font-medium">
            <p class="text-4xl text-darkAqua font-semibold md:text-left text-center text-poppins">Por Pensión</p>
            <p class="text-2xl mt-2 md:text-left text-center text-roboto">
              Los Socios del FAS que se pensionen, que se inscribieron hasta el día 15 de Mayo de 2010,
              tendrán derecho a recibir un porcentaje del monto que se hubiere recibido en caso de jubilación
              de la siguiente manera:
            </p>
            <p class="text-2xl mt-5 font-black md:text-left text-center text-roboto">
              Durante los primeros 5 años completos aportando al Fondo de Retiro desde su inscripción, 
              tendrá derecho al total de las aportaciones más la parte proporcional de los intereses 
              generados en el Fondo de Retiro.
            </p>
            <p class="text-2xl mt-5 md:text-left text-center text-roboto">
              Después de 5 años, se recibirá el beneficio conforme a la siguiente tabla:
            </p>

            <div>
              <table class="table mt-10">
                <tr>
                  <th colspan="2" class="text-center">
                    TIEMPO DE SERVICIO % del Beneficio por Retiro (% de $27,500.00)
                  </th>
                </tr>
                <tbody>
                  <tr>
                    <td>Después de 5 años completos y hasta 10 años de servicio recibirán el</td>
                    <td class="text-center">25%</td>
                  </tr>
                  <tr>
                    <td>De 11 a 15 años de servicio recibirán el</td>
                    <td class="text-center">40%</td>
                  </tr>
                  <tr>
                    <td>De 16 a 20 años de servicio recibirán el</td>
                    <td class="text-center">50%</td>
                  </tr>
                  <tr>
                    <td>De 21 a 25 años de servicio recibirán el</td>
                    <td class="text-center">75%</td>
                  </tr>
                  <tr>
                    <td>De 26 años de servicio en adelante recibirán el</td>
                    <td class="text-center">100%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="md:col-span-2 md:flex-none flex justify-center">
            <div style="display:table;">
              <div style="display:table-cell;vertical-align:top">
                <img src="@/assets/beneficio-defuncion.svg" alt="">
              </div>
            </div>
          </div>
          <div class="md:col-span-10 text-left font-medium">
            <p class="text-4xl text-darkAqua font-semibold md:text-left text-center text-poppins">Por Defunción</p>
            <p class="text-2xl mt-2 md:text-left text-center text-roboto">
              Si el Socio del FAS fallece, los beneficiarios designados en la Cédula Testamentaria 
              (Formato de Inscripción) tendrán el derecho de recibir el 100% de las aportaciones efectuadas
              al Fondo de Retiro, más los intereses que proporcionalmente le correspondan y que se hayan generado.
            </p>
          </div>
          <div class="md:col-span-2 md:flex-none flex justify-center">
            <div style="display:table;">
              <div style="display:table-cell;vertical-align:top">
                <img src="@/assets/beneficio-retiro.svg" alt="">
              </div>
            </div>
          </div>
          <div class="md:col-span-10 text-left font-medium">
            <p class="text-4xl text-darkAqua font-semibold md:text-left text-center text-poppins">Por Retiro Voluntario</p>
            <p class="text-2xl mt-2 md:text-left text-center text-roboto">
              Los Socios del FAS que se retiren del servicio por cualquier causa, que no sea Jubilación o Pensión, 
              tendrán el derecho de recibir el 100% de las aportaciones efectuadas al Fondo de Retiro más 
              los intereses que proporcionalmente le correspondan, que se hayan generado en este Fondo y que estén 
              reflejados en su último estado de cuenta.
            </p>
            <p class="text-2xl mt-5 md:text-left text-center text-roboto">
              - En caso de que el Socio, debido al tiempo de servicio que tuviera a la fecha de que entre 
              en vigor el presente Reglamento, aportara una cantidad mayor a <span class="font-black">$27,500.00</span>, 
              se le reintegrará el total aportado más la parte proporcional de los intereses 
              generados en el Fondo de Retiro.
            </p>
          </div>
        </div>
      </div>
      <div class="p-2 mt-5 mb-5 lg:inline-flex xl:inline-flex" style="display:flex;justify-content:center;">
        <div style="width:80%;" class="font-normal">
          <p class="text-2xl md:text-left text-center text-roboto">
            *NOTA: A partir del día 16 de Mayo de 2010, el monto del beneficio por Retiro será conforme 
            lo que indique la Valuación Actuarial Personalizada para cada Socio de nuevo ingreso. 
            Todos los Socios vigentes tendrán derecho a solicitar una Valuación Actuarial Personalizada, 
            con la finalidad de solicitar un aumento en el monto del beneficio y éste será también como 
            lo indique la Valuación mencionada.
          </p>
          <p class="text-2xl md:text-left text-center mt-5 text-roboto">
            Una vez que el Socio del FAS haya cobrado el beneficio de Retiro, no tendrá derecho bajo 
            ninguna circunstancia a reingresar a este Fondo.
          </p>
        </div>
      </div>
      <div class="p-2 mt-5 mb-5" style="display:flex;justify-content:center;">
        <div class="font-normal w-4/5">
          <button @click="reedirect('RetirementRequest')" class="text-2xl md:w-80 sm-full h-16 bg-lightAqua hover:bg-darkAqua text-white font-bold py-2 px-4 rounded mt-5">
            Registrar Solicitud de Retiro
          </button>
        </div>
      </div>
    </div>
    <div class="footer mt-20">
      <p class="text-center font-bold text-3xl">&copy; FAS Sección 17.</p>
      <p class="text-center font-bold text-3xl">Todos los derechos reservados.</p>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {

    }
  },
  name: 'LandingRetirementComponent',
  methods: {
    reedirect(pathName) {
      this.$router.push({ name: pathName });
    }
  }
}
</script>

<style scoped>

.title {
  font-family: Poppins;
}

.text-roboto {
  font-family: Roboto;
}

.text-poppins {
  font-family: Poppins;
}

table, th, td {
  border: 2px solid #198F99; 
  font-family: Roboto;
}
.footer {
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #003A3E;
  color: white;
  text-align: center;
  padding: 28px 0px 28px 0px;
  font-family: Roboto;
}
</style>